import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const IconListCard = ({ icon: Icon, title, intro, items, footer }) => (
  <Card className="border-2">
    <CardContent className="p-8 space-y-6">
      <div className="flex items-center space-x-3">
        <div className="bg-blue-100 rounded-full p-3">
          <Icon className="w-6 h-6 text-blue-600" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900">{title}</h3>
      </div>
      {intro && <p className="text-gray-600">{intro}</p>}
      <ul className="space-y-3">
        {items.map((item) => (
          <li key={item} className="flex items-start space-x-3">
            <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
            <span className="text-gray-700">{item}</span>
          </li>
        ))}
      </ul>
      {footer && <p className="text-sm text-gray-600 italic mt-4">{footer}</p>}
    </CardContent>
  </Card>
);

export default IconListCard;
